import React, { useState } from "react";
import "./Login.css";
import LoginWithMpin from "./LoginWithMpin";
import LoginWithPassWord from "./LoginWithPassWord";
import TempMpin from "./TempMpin";
import ForgotPassOtp from "./ForgotPassOtp";
import ForgotMpinOtp from "./ForgotMpinOtp";
import VerifyEmailMobile from "../Register/VerifyEmailMobile";
import axios from "../../axios";

export default function LoginMpinPassWord({
  studentDetails,
  setEmailPhoneVerification,
  emailPhoneVerification,
  setRegister,
  register,
  setIsInProgress,
  setSearchParams,
  inputValue,
  inputSchoolCode,
}) {
  const [login, setLogin] = useState({
    mpinLogin: false,
    passwordLogin: false,
    loginTempMpin: false,
  });

  const schoolCode = localStorage.getItem("schoolCode");

  const [unregisterID, setUnregisterID] = useState(false);

  const updateQueryParam = async () => {
    // debugger;
    // setIsInProgress(true);
    try {
      let response = await axios.post(`/studentAuth/validateUniqueId`, {
        unique_id: studentDetails?.addmissionNumber,
        school_code: schoolCode,
      });
      if (response) {
        if (response.data.status === "Registered") {
          setRegister({
            ...register,
            verify: true,
            studentDetails: response.data.data,
          });
          setSearchParams({
            unreg: "true",
            userId: studentDetails?.addmissionNumber,
          });
          setUnregisterID(true);
        } else {
          //todo maybe add a popup
        }
      }
    } catch (error) {
      // setIsInProgress(false);
      console.log(error);
    }
  };

  const [forget, setForget] = useState();

  return (
    <div>
      {!login.mpinLogin && !login.passwordLogin && !login.loginTempMpin && (
        <div className="ContainerRegister h-100">
          <div className="row">
            <div className="col-md-3 p-0 bannerContainer">
              <img
                className="bannerImg"
                alt="icon"
                src="/LoginRegister/BannerImg.png"
              ></img>
            </div>
            <div className="col-md-9 RegisterDetailContainer">
              <>
                <div
                  className="backLoginIcon"
                  onClick={(e) => {
                    setIsInProgress(false);
                    setRegister(() => ({ userValid: false }));
                  }}
                >
                  <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
                </div>
                <form>
                  <div>
                    <div className="d-flex justify-content-center">
                      <img
                        className="registrationIcon"
                        src="/StudentImg/BreathSchoolLogo.png"
                        alt="icon"
                      />
                    </div>
                    <div className="d-flex justify-content-center headerRegistration mt-3">
                      Hello! {studentDetails?.name}
                    </div>
                    <div className="UnlockFaceIdText d-flex justify-content-center mt-2 ">
                      Choose your login preference
                    </div>
                    <div className="mt-4">
                      <button
                        className="EnterMpinBtn"
                        onClick={(e) => {
                          setLogin({ ...login, mpinLogin: true });
                        }}
                      >
                        Enter Pin
                      </button>
                    </div>
                    <div className="horizontalLine_Container mt-4">
                      <span className="horizontalLine_text">Or</span>
                    </div>
                    <div className="mt-4">
                      <button
                        className="EnterMpinBtn"
                        onClick={(e) => {
                          setLogin({ ...login, passwordLogin: true });
                        }}
                      >
                        Enter Password
                      </button>
                    </div>
                    <div className="skipfacetext d-flex justify-content-end mt-3">
                      <span onClick={() => setForget("pin")}>Forgot PIN</span>{" "}
                      &nbsp; / &nbsp;{" "}
                      <span onClick={() => setForget("password")}>
                        Password?
                      </span>
                    </div>
                    <p
                      style={{
                        position: "absolute",
                        textAlign: "center",
                        bottom: "30px",
                        marginLeft: "30px",
                      }}
                    >
                      To unregister the registered ID{" "}
                      {/* <span
                        style={{
                          color: "#EE8900",
                          borderBottom: "1px solid #EE8900",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (studentDetails?.addmissionNumber) {
                            updateQueryParam();
                          }
                        }}
                      >
                        Click here
                      </span>{" "} */}
                      <span
                        disabled={!studentDetails?.addmissionNumber}
                        className={`px-3 py-1.5 rounded-md text-sm cursor-pointer font-medium transition ${
                          studentDetails?.addmissionNumber
                            ? "bg-orange-400 text-white hover:bg-orange-500"
                            : "bg-gray-300 text-gray-500"
                        }`}
                        onClick={() => {
                          if (studentDetails?.addmissionNumber) {
                            updateQueryParam();
                          } else {
                            toast.error("Addmission Number is mandatory!!");
                          }
                        }}
                      >
                        Click here
                      </span>{" "}
                    </p>

                    {/* <div className=" d-flex justify-content-center">
                    <div
                      className="LoginWithPassTemp mb-3"
                      onClick={(e) => {
                        setLogin({ ...login, loginTempMpin: true });
                      }}
                    >
                      Login with temp password
                    </div>
                  </div> */}
                  </div>
                </form>
              </>
            </div>
          </div>
        </div>
      )}

      {login.mpinLogin && (
        <LoginWithMpin
          studentDetails={studentDetails}
          setLogin={setLogin}
          setRegister={setRegister}
          setIsInProgress={setIsInProgress}
        />
      )}
      {login.passwordLogin && (
        <LoginWithPassWord
          studentDetails={studentDetails}
          setLogin={setLogin}
          setRegister={setRegister}
          setIsInProgress={setIsInProgress}
        />
      )}

      {forget === "password" && (
        <ForgotPassOtp
          inputSchoolCode={inputSchoolCode}
          inputValue={inputValue}
          studentDetails={studentDetails}
          setRegister={setRegister}
          setIsInProgress={setIsInProgress}
        />
      )}
      {forget === "pin" && (
        <ForgotMpinOtp
          inputSchoolCode={inputSchoolCode}
          inputValue={inputValue}
          studentDetails={studentDetails}
          setRegister={setRegister}
          setIsInProgress={setIsInProgress}
        />
      )}
      {unregisterID && (
        <VerifyEmailMobile
          studentDetails={register.studentDetails}
          setEmailPhoneVerification={setEmailPhoneVerification}
          emailPhoneVerification={emailPhoneVerification}
          setRegister={setRegister}
          setIsInProgress={setIsInProgress}
        />
      )}

      {/* {login.loginTempMpin && <TempMpin />} */}
    </div>
  );
}
